export default { sha: '7d1ad436d7abb511e500c5f82c9472be61ad6140', buildNumber: 'undefined' }
